import { Col, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { formatCurrency } from '@opendoor/shared-fe/formatUtils';
import { formatStreetAddress } from 'components/marketplace/helpers/addressHelpers';
import { getDisplayPrice } from 'components/marketplace/helpers/displayPrice';
import type { MarketplaceProperty } from 'components/marketplace/property/types';
import { isPropertyAvailableForPurchase } from 'components/properties/helpers/property';

import { PricingTraditional } from './Pricing';

interface PropertySummaryProps {
  property: MarketplaceProperty;
}
export const MiniMapPropertySummary = ({ property }: PropertySummaryProps) => {
  const formattedStreet = formatStreetAddress(
    property.street,
    property.unitType,
    property.unitNumber,
  );
  const availableForPurchase = isPropertyAvailableForPurchase(property);
  const locality = [property.city, property.state].filter(Boolean).join(', ');

  return (
    <Col className="lg:hidden">
      <Text as="h1" className="pb-6 text-subheader-xs font-normal text-od-content-primary">
        <Text as="span" className="text-subheader-xs font-normal">
          {formattedStreet}
        </Text>
        <br />
        <Text as="span" className="text-subheader-xs font-normal">
          {[locality, property.zip].filter(Boolean).join(' ')}
        </Text>
      </Text>
      <Col as="section">
        <PricingTraditional price={getDisplayPrice(property, 'listed')} />
        <Row>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {property.bedrooms} bds
          </Text>
          <Text as="span" className="px-1 text-body-sm text-od-content-inactive-primary">
            ·
          </Text>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {property.bathrooms} ba
          </Text>
          <Text as="span" className="px-1 text-body-sm text-od-content-inactive-primary">
            ·
          </Text>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {property.sqFtTotalLiving} sqft
          </Text>
          {availableForPurchase && property.estimatedMonthlyPayment && (
            <>
              <Text as="span" className="px-1 text-body-sm text-od-content-inactive-primary">
                ·
              </Text>
              <Text className="text-body-sm text-od-content-secondary">
                {`${formatCurrency(property.estimatedMonthlyPayment)}/month est.`}
              </Text>
            </>
          )}
        </Row>
        <Row>
          <Text as="span" className="text-body-sm text-od-content-secondary">
            {!!property.schoolDistricts.length && property.schoolDistricts.join(' & ')}
          </Text>
        </Row>
      </Col>
    </Col>
  );
};
